import { component } from 'picoapp';
import {
  Autoplay, EffectFade, Navigation, Pagination,
} from 'swiper';

class Hero {
  constructor({ element }) {
    this.video = element.querySelector('.js-video');
    this.videoPlayBtns = element.querySelectorAll('.js-videoPlayBtn');

    this.init = this.init.bind(this);
    this.initVideo = this.initVideo.bind(this);

    this.init();
  }

  initVideo() {
    if (this.video && this.videoPlayBtns.length) {
      this.videoPlayBtns.forEach((button) => {
        const video = button.parentElement.querySelector('video');
        button.addEventListener('click', () => {
          video.play();
          button.hidden = true;
        });

        // If button is hidden, autoplay video
        if (button.offsetParent === null) {
          button.click();
        }
      });
    }
  }

  init() {
    this.initVideo();
  }
}

export default component(async (node) => {
  (() => new Hero({ element: node }))();

  const slider = node.querySelector('[data-slider]');

  if (slider) {
    const initSwiper = async () => {
      const Swiper = (await import(
        /* webpackChunkName: "swiper" */
        'modules/swiper'
      )).default;

      const swiperParams = {
        modules: [Autoplay, EffectFade, Navigation, Pagination],
        init: false,
        slidesPerView: '1',
        spaceBetween: 0,
        loop: true,
        effect: 'fade',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        fadeEffect: {
          crossFade: true,
        },
        autoplay: {
          delay: parseInt(slider.dataset.delay, 10) * 1000,
          disableOnInteraction: false,
        },
      };

      const carousel = new Swiper(slider, swiperParams);
      carousel.init();
    };

    const observer = new IntersectionObserver((entires) => {
      entires.forEach((entry) => {
        if (entry.isIntersecting) {
          initSwiper();

          observer.disconnect();
        }
      });
    });

    observer.observe(node);
  }
});
